import { Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Log } from 'src/app/core/console.log';
import { DropdownModel } from 'src/app/models/master/dropdown-model';
import { MasterService } from 'src/app/services/master.service';
import { inputMgsErrs } from 'src/app/validators/message-validation';
import { DropdownFormControl } from '../dropdown-form-control';

@Component({
  selector: 'app-input-dp-tax-rate',
  templateUrl: './input-dp-tax-rate.component.html',
  styleUrls: ['./input-dp-tax-rate.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDpTaxRateComponent),
      multi: true
    }
  ]
})

export class InputDpTaxRateComponent extends DropdownFormControl implements OnInit {
  @Input() label: any;
  errors = inputMgsErrs.tax;


  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private translate: TranslateService,
    private masterService: MasterService
  ) {
    super(cc);
  }

  ngOnInit() {
    this.checkInitialControl();
    this.initDropdownList();
  }

  protected filterSearchItemCustom(search: string, item: DropdownModel): boolean {
    return super.filterSearchItemCustom(search, item)
      || (item.data.code ? item.data.code.search(search) !== -1 : false);
  }

  initDropdownList() {
    this.resetDropdownList();
    let defaul;
    this.masterService.getTaxRate().subscribe(result => {
      this.items.push(...result);
      defaul = this.items.find((item) => item.data.code == 1);
      if (this.value != null) {
        this.findValueFromList(this.value);
      } else if (this.control.status != "DISABLED") {
        this.value = defaul.value;
        this.findValueFromList(this.value);
      } else {
        this.findValueFromList(this.value);
      }
      this.setAfterLoadItemDropdown();
    }, error => {
      Log.error(error);
    });
  }

  resetDropdownList() {
    this.items
    // this.translate.get('input.dropdown.select.default').subscribe(label => {
    //   this.items.push({ value: null, label: label, data: null });
    // });
  }

}
